const consent = {
  title: "ประกันเดินทางภายในประเทศ",
  description: `
  ไปเที่ยวกันเถอะ ! ให้ประกันเดินทางในประเทศ TA ปันสุขดูแลคุณตลอดทริปจ่ายหลักสิบ คุ้มครองหลักแสน!`,
  benefits: [
    {
      title: "",
      detail: "หมวดความคุ้มครอง",
      items: [
        {
          index: `1. การสูญเสียชีวิตหรืออวัยวะ (มือ เท้า) สายตา และทุพพลภาพถาวรสิ้นเชิงเนื่องจากอุบัติเหตุ (รวมการถูกฆาตกรรม / ทำร้ายร่างกาย) ระหว่างการเดินทาง`,
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "200,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "500,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000,000",
                },

              ],
            },
          ],
        },
        {
          index: "2. การสูญเสียชีวิตหรืออวัยวะ (มือ เท้า) สายตา และทุพพลภาพถาวรสิ้นเชิง เนื่องจากการขับขี่/โดยสารรถจักรยานยนต์",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "200,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "500,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "3. ค่ารักษาพยาบาลเนื่องจากอุบัติเหตุ",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "100,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "100,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "100,000",
                },
              ],
            },
          ],
        },
        {
          index: "4. การยกเลิกการเดินทาง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "5,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "10,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "15,000",
                },
              ],
            },
          ],
        },
        {
          index: "5. การสูญเสีย เสียหาย หรือสูญหายต่อสัมภาระในการเดินทางและทรัพย์สินส่วนตัว",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "5,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "10,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "15,000",
                },
              ],
            },
          ],
        },
        {
          index: "6. ความรับผิดชอบต่อบุคคลภายนอก",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "200,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "500,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "7. ค่าใช้จ่ายในการลดจำนวนวันเดินทาง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "2,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "5,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "10,000",
                },
              ],
            },
          ],
        },
      ],
      timesHeaders: [
        "แบบที่ 1",
        "แบบที่ 2",
        "แบบที่ 3",
      ],
      times: [
        {
          day: "1 - 4 วัน",
          price: {
            "แบบที่ 1": 48,
            "แบบที่ 2": 95,
            "แบบที่ 3": 160,
          },
        },
        {
          day: "5 - 7 วัน",
          price: {
            "แบบที่ 1": 79,
            "แบบที่ 2": 185,
            "แบบที่ 3": 310,
          },
        },
        {
          day: "8 - 10 วัน",
          price: {
            "แบบที่ 1": 110,
            "แบบที่ 2": 258,
            "แบบที่ 3": 450,
          },
        },
        {
          day: "11 - 14 วัน",
          price: {
            "แบบที่ 1": 150,
            "แบบที่ 2": 352,
            "แบบที่ 3": 642,
          },
        },
      ],
    },
  ],
  conditions: [
    {
      title: "",
      detail: "เงื่อนไขการรับประกันภัย",
      items: [
        {
          index:
            "1. ผู้เอาประกันภัย ต้องมีอายุ 1- 70 ปี ใช้ปีเกิดเทียบกับวันที่ตกลงทำประกันภัย",
        },
        {
          index:
            "2. ในช่วงเวลาเดินทางเดียวกัน ผู้เอาประกันภัย 1 คน สามารถทำประกันได้คนละ 1 ฉบับเท่านั้น",
        },
        {
          index:
            "3. รับประกันภัยเฉพาะคนไทยที่เดินทางภายในประเทศไทยเท่านั้น",
        },
        {
          index:
            "4. ต้องมีสุขภาพร่างกายแข็งแรงสมบูรณ์ ไม่มีส่วนใดส่วนหนึ่งพิการ ทุพพลภาพ ไม่มีโรคประจำตัวเรื้อรัง โรคร้ายแรง หรือได้รับบาดเจ็บ และไม่เป็นผู้วิกล",
        },
      ],
    },
  ],
  exceptions: [
    {
      title: "",
      detail: "หมายเหตุ",
      items: [
        {
          index: "1. เงื่อนไขความคุ้มครองและข้อยกเว้นเป็นไปตามกรมธรรม์",
        },
        {
          index:
            "2. ผู้ซื้อควรทำความเข้าใจในรายละเอียดความคุ้มครองและเงื่อนไขก่อนตัดสินใจทำประกันภัย",
        },
      ],
    },
  ],
  services: [
    {
      title: "",
      detail: "ศูนย์บริการลูกค้า (Customer Service Center)",
      items: [
        {
          index: "<li> ทาง Call Center โทร.1484",
        },
      ],
    },
  ],
};

export default consent;
